import React, { useState } from "react";

import "../styles/header_box.sass";
import CheckWidth from "../CheckWidht";
import BookVisit from "../BookVisit";

const HeaderBox = () => {
  const [bookVisit, setBookVisit] = useState(false);
  const width = CheckWidth();
  return (
    <header>
      <div>
        <div className='black_bgc'>
          <h1>
            Witamy w Boro <span>Cars</span>!
          </h1>
          <p>
            Profesjonalne naprawy i usługi mechaniczne na najwyższym poziomie.
          </p>
          {width < 1024 ? (
            <a className='book_visit' href='tel:+48533340065'>
              Umów wizytę
            </a>
          ) : (
            <button
              className='book_visit'
              onClick={() => {
                setBookVisit((visit) => !visit);
              }}
            >
              Umów wizytę
            </button>
          )}
        </div>
        <div className='main_header_img'></div>

        {/* <BookVisit/> */}
      </div>
      {width >= 1024 && bookVisit && <BookVisit setBookVisit={setBookVisit} />}
    </header>
  );
};
export default HeaderBox;
